module.exports = __webpack_public_path__ + "static/img/517_phase_function_Paper_PointsHejduk_Prediction.aaa57a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/517_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 0Foh
// module chunks = 0